import { useEffect, useState } from 'react'
import { useToast } from '@/components/providers/ToastProvider'
import { supabase } from '@/lib/supabase'
import { logWarn } from '@/lib/log'
import { recordBreadcrumb } from '@/lib/sentry'
import { consumeIntentionalSignOut } from '@/lib/signOutIntent'

export function NetworkStatusHandler() {
  const { showWarning, showSuccess } = useToast()
  const [isOffline, setIsOffline] = useState(!navigator.onLine)

  useEffect(() => {
    const handleOnline = () => {
      if (isOffline) {
        setIsOffline(false)
        showSuccess(
          'Bağlantı Kuruldu',
          'İnternet bağlantınız tekrar sağlandı.',
        )
      }
    }

    const handleOffline = () => {
      if (!isOffline) {
        setIsOffline(true)
        showWarning(
          'Bağlantı Koptu',
          'Lütfen internet bağlantınızı kontrol edin. Çevrimdışısınız.'
        )
      }
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [isOffline, showWarning, showSuccess])

  // Handle Supabase auth state change globally for token expiry loops
  useEffect(() => {
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, _session) => {
      if (event === 'SIGNED_OUT') {
        const currentPath = window.location.pathname
        if (currentPath !== '/login' && currentPath !== '/' && currentPath !== '/onboarding') {
          // Kullanıcının kendi çıkışı beklenen durumdur; yalnız kendiliğinden düşen oturum uyarıdır.
          if (consumeIntentionalSignOut()) {
            recordBreadcrumb('Kullanıcı kendi isteğiyle çıkış yaptı', { path: currentPath })
          } else {
            logWarn('[NetworkStatusHandler] Beklenmeyen oturum kaybı, girişe yönlendiriliyor')
          }
          // Local storage session drop workaround
          localStorage.removeItem('supabase.auth.token')
          window.location.href = '/login'
        }
      }
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [])

  return null
}
